import React from 'react'

import PropTypes from 'prop-types'

import {
  AdDetailsTcAdevinta,
  AdDetailsTcBbva,
  AdDetailsTcBbvaWithoutInsurance,
  AdDetailsTcBmwBank,
  AdDetailsTcBmwBankMultiBrand,
  AdDetailsTcCaixa,
  AdDetailsTcConfia,
  AdDetailsTcLendrock,
  AdDetailsTcLendrockShort,
  AdDetailsTcMobilize,
  AdDetailsTcSantander,
  AdDetailsTcSantanderPri,
  AdDetailsTcSantanderWithCasualtyInsurance,
  AdDetailsTcSantanderWithoutInsurance,
  AdDetailsTcStellantis,
  AdDetailsTcVwfs
} from '@adv-mt/mt-react-markdown'

import Wrapper from '../wrapper.js'

const contentMap = {
  adevinta: AdDetailsTcAdevinta,
  bbva: AdDetailsTcBbva,
  'bbva-without-insurance': AdDetailsTcBbvaWithoutInsurance,
  'bmw-bank': AdDetailsTcBmwBank,
  'bmw-bank-multi-brand': AdDetailsTcBmwBankMultiBrand,
  santander: AdDetailsTcSantander,
  'santander-pri': AdDetailsTcSantanderPri,
  'santander-with-casualty-insurance': AdDetailsTcSantanderWithCasualtyInsurance,
  'santander-without-insurance': AdDetailsTcSantanderWithoutInsurance,
  caixa: AdDetailsTcCaixa,
  lendrock: AdDetailsTcLendrock,
  'lendrock-short': AdDetailsTcLendrockShort,
  mobilize: AdDetailsTcMobilize,
  'mobilize-nissan': AdDetailsTcMobilize,
  'mobilize-nissan-nsfs': AdDetailsTcMobilize,
  stellantis: AdDetailsTcStellantis,
  vwfs: AdDetailsTcVwfs,
  confia: AdDetailsTcConfia
}

const MarkdownAdDetailsTc = ({documentName, tenant, parser}) => {
  const Content = contentMap[documentName] ?? AdDetailsTcAdevinta

  return (
    <Wrapper>
      <Content tenant={tenant} parser={parser} />
    </Wrapper>
  )
}

MarkdownAdDetailsTc.displayName = 'MarkdownAdDetailsTc'

MarkdownAdDetailsTc.propTypes = {
  documentName: PropTypes.string.isRequired,
  tenant: PropTypes.string,
  parser: PropTypes.func
}

export default MarkdownAdDetailsTc
